import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

/**
 * Migration to convert ceilingVerticalOffset to ceilingDatum.
 * Creates new datum entities in the datums table for each unique offset value,
 * and references them from ceilings. The offset is stored in the datum entity,
 * not in the datumUsage.
 */
const migration: DocMigration = {
  id: "add_ceiling_datum",
  description: "Convert ceilingVerticalOffset to ceilingDatum",
  apply(json: any, _warnings: string[], _errors: string[]): any {
    if (!json.ceilings) {
      return json;
    }

    // Initialize datums table if it doesn't exist
    if (!json.datums) {
      json.datums = {};
    }

    const ceilings = json.ceilings;
    const ceilingIds = Object.keys(ceilings);

    // Map of offset value to datum ID (to reuse datums with the same offset)
    const offsetToDatumId: Map<number, string> = new Map();
    for (const ceilingId of ceilingIds) {
      const ceiling = ceilings[ceilingId];
      if (typeof ceiling.ceilingVerticalOffset === "number") {
        const offset = ceiling.ceilingVerticalOffset;

        // Get or create a datum for this offset value
        let datumId = offsetToDatumId.get(offset);
        if (!datumId) {
          datumId = uid();
          json.datums[datumId] = {
            entityType: "DATUM",
            id: datumId,
            sortIndex: 0,
            name: `Ceiling offset ${offset}`,
            datumType: "LEVEL",
            direction: "VERTICAL",
            offsetType: "RELATIVE",
            offset: offset,
            anchor: "LEVEL_TOP_OF_WALL",
            justification: "BOTTOM_UP",
            offsetNormalized: false,
          };

          offsetToDatumId.set(offset, datumId);
        }

        // Reference the datum from the ceiling (without offset in datumUsage)
        ceiling.ceilingDatum = {
          __usage: "CEILING",
          entityId: datumId,
        };

        // Remove the old ceilingVerticalOffset field
        delete ceiling.ceilingVerticalOffset;
      }
    }

    return json;
  },
};

export default migration;
